import { QueryClient } from "@tanstack/react-query"
import { isApiError } from "./api"

// QueryClient compartido de la consola: sin reintentos para errores 4xx
// (son deterministas) y máximo dos para fallos de red o 5xx.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isApiError(error) && error.status >= 400 && error.status < 500) return false
        return failureCount < 2
      },
    },
    mutations: {
      retry: false,
    },
  },
})
